const STATUS_PRESENTATIONS = {
  idle: { label: 'Ожидание', tone: 'neutral' },
  new: { label: 'Новый', tone: 'info' },
  queued: { label: 'В очереди', tone: 'info' },
  pending: { label: 'Ожидает', tone: 'warning' },
  running: { label: 'Выполняется', tone: 'info' },
  processing: { label: 'В работе', tone: 'info' },
  creating: { label: 'Создаётся', tone: 'info' },
  cdek_created: { label: 'Создано в СДЭК', tone: 'info' },
  created: { label: 'Создано', tone: 'success' },
  accepted: { label: 'Принято СДЭК', tone: 'info' },
  waiting: { label: 'Обрабатывается СДЭК', tone: 'info' },
  exported: { label: 'Выгружено', tone: 'success' },
  embedded: { label: 'Индексировано', tone: 'success' },
  classified: { label: 'Классифицировано', tone: 'success' },
  manual_assigned: { label: 'Назначено вручную', tone: 'success' },
  manual_review: { label: 'Нужна проверка', tone: 'warning' },
  manual_check: { label: 'Требуется ручная проверка', tone: 'warning' },
  skipped: { label: 'Пропущено', tone: 'neutral' },
  skipped_unchanged: { label: 'Без изменений', tone: 'neutral' },
  done: { label: 'Готово', tone: 'success' },
  completed: { label: 'Завершено', tone: 'success' },
  deleted: { label: 'Удалено', tone: 'neutral' },
  cancelled: { label: 'Остановлено', tone: 'warning' },
  failed: { label: 'Ошибка', tone: 'danger' },
  invalid: { label: 'Ошибка СДЭК', tone: 'danger' },
  ms_failed: { label: 'Ошибка МойСклад', tone: 'danger' },
  error: { label: 'Ошибка', tone: 'danger' }
};

export function statusPresentation(status, fallback = 'Нет данных') {
  const normalized = String(status || '').trim().toLowerCase();
  if (!normalized) return { label: fallback, tone: 'neutral', value: '' };
  return {
    ...(STATUS_PRESENTATIONS[normalized] || {
      label: 'Неизвестный статус',
      tone: 'neutral'
    }),
    value: normalized
  };
}

export function statusLabel(status, fallback) {
  return statusPresentation(status, fallback).label;
}

export function statusClassName(status, prefix = 'status-badge') {
  return `${prefix} ${prefix}--${statusPresentation(status).tone}`;
}
